import get from 'lodash.get';
import { config } from '@yola/ws-sdk';

const getCalendlyDifmPromoOnboardingUrl = (rootState) => {
  const cfg = config.selectors.getConfig(rootState);

  return get(cfg, 'common.calendly.difm_promo_onboarding_url', '');
};

export default getCalendlyDifmPromoOnboardingUrl;
